import { IDatasetTypeMetadata, IDynamicDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { maxConcurrentConnectionsMetadata, preCopyScriptMetadata, queryTimeoutMetadata, stringTimestampConversion } from '../consts/metadata-consts';
import { cloneDeep } from 'lodash';
import { Constants, format } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';

const timeoutControlMetadata = cloneDeep(queryTimeoutMetadata);
timeoutControlMetadata.description = stringResources.PostGreSQL_QueryTimeout_DescriptionMessage_short;
timeoutControlMetadata.escapeDescription = false;
timeoutControlMetadata.child.description = stringResources.PostGreSQL_QueryTimeout_DescriptionMessage_short;
timeoutControlMetadata.child.escapeDescription = false;

export const postgreSqlTableV2Metadata: IDynamicDatasetTypeMetadata = async () => {
    const metadata: IDatasetTypeMetadata = {
        type: __IS_FABRIC_DPE__ ? adfModelTypeMap.postgreSql.datasetType : adfModelTypeMap.postgreSqlV2.datasetType,
        displayName: stringResources.PostgreSql_DisplayText,
        datasetNamePrefix: adfModelTypeMap.postgreSql.datasetType,
        supportLinkedServiceTypes: [__IS_FABRIC_DPE__ ? adfModelTypeMap.postgreSql.linkedServiceType : adfModelTypeMap.postgreSqlV2.linkedServiceType],
        isSource: true,
        isSink: __IS_FABRIC_DPE__,
        datasetKind: 'table',
        icon: {
            className: 'svg-i-100x100-PostgreSQL'
        },
        isFirstClass: true,
        supportCreatedAsV2: true,
        notSupportPhysicalType: true,
        splitTablePath: true,
        supportAutoTableCreation: __IS_FABRIC_DPE__ && GlobalVariables.pgSinkAutoCreate,
        category: ['Database'],
        copySourceControls: [timeoutControlMetadata],
        copySinkControls: __IS_FABRIC_DPE__ ? [
            preCopyScriptMetadata(),
            {
                type: 'parameterizable',
                child: {
                    type: 'textbox',
                    bind: 'writeBatchTimeout',
                    label: stringResources.ModelName_WriteBatchTimeout,
                    validators: [
                        {
                            type: 'pattern',
                            pattern: Constants.timeoutValidationPattern,
                            errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                        }
                    ]
                },
                dynamicContentTextClass: 'input-spaced'
            },
            {
                type: 'parameterizable',
                child: {
                    type: 'textbox-number',
                    bind: 'writeBatchSize',
                    label: stringResources.ModelName_WriteBatchSize,
                    inputType: 'number',
                    min: 0
                },
                dynamicContentTextClass: 'input-spaced'
            },
            maxConcurrentConnectionsMetadata
        ] : undefined,
        copyJob: {
            multipleQuery: true,
            incrementalColumnConversion: {
                supportConversion: true,
                conversionMapping: {
                    ...stringTimestampConversion
                }
            }
        }
    };
    return metadata;
};
